import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@heidi/design-system/alert-dialog';
import { useIntl } from 'react-intl';

import { voiceAssistantMessages as messages } from './voice-assistant.messages';

interface VoiceAssistantEndDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Confirmed end — tear down the realtime session, stop the mic, reset. */
  onConfirm: () => void;
}

/**
 * Confirm before ending a live Talk to Heidi session. Ending stops the mic and
 * clears the conversation, so it is gated behind this AlertDialog while a
 * session is live (AGE-1622). Minimising, which keeps the session running, is
 * offered as the non-destructive alternative in the copy.
 */
export function VoiceAssistantEndDialog({
  open,
  onOpenChange,
  onConfirm,
}: VoiceAssistantEndDialogProps) {
  const intl = useIntl();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {intl.formatMessage(messages.endConfirmTitle)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {intl.formatMessage(messages.endConfirmDescription)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {intl.formatMessage(messages.endConfirmCancel)}
          </AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={() => {
              onOpenChange(false);
              onConfirm();
            }}
          >
            {intl.formatMessage(messages.endConfirmConfirm)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
